import { useEffect, useRef, useState } from 'react';

import useAutoBlockedModalStore from '../store/useAutoBlockedModal.store';

interface Props {
  visible?: boolean;
}

const useAutoBlockedModal = ({ visible }: Props) => {
  const { pushModalLayer, popModalLayer, isTopModal } = useAutoBlockedModalStore();
  const [modalLayer, setModalLayer] = useState<number | null>(null);
  const wasVisible = useRef<boolean>(false);

  useEffect(() => {
    if (visible) {
      const currentModalLayer = pushModalLayer();
      setModalLayer(currentModalLayer);
      wasVisible.current = true;
    }
  }, [visible, pushModalLayer]);

  useEffect(() => {
    if (wasVisible.current && !visible) {
      popModalLayer();
    }
  }, [visible, popModalLayer]);

  useEffect(() => {
    return () => {
      popModalLayer();
    };
  }, [popModalLayer]);

  return {
    isClosingByClickOutsideBlocked: Boolean(modalLayer && !isTopModal(modalLayer)),
  };
};

export default useAutoBlockedModal;
